
const PromotionTypes = {
  GigPromo : 1,
  MembershipPromo : 2
};

export default PromotionTypes;
